<template lang="pug">
nuxt-link(
    :to="{ name: 'builds-detail', params: { buildId: build.objectID }}"
    class="rounded"
    :key="build.objectID"
)
    div
        img(
            class="w-full rounded-t"
            v-bind="image"
            :key="image.src"
            :alt="`Image of ${build.title}`"
            :loading="isLazy ? 'lazy' : 'eager'"
        )

    div(class="bg-gray-darkest w-full rounded-b p-4 text-gray")
        div(class="font-bold text-white capitalize text-2xl text-left leading-8") {{ build.title }}
        div(class="text-sm text-left") {{ `${build.year} ${build.make} ${build.model}` }}
        div(class="flex justify-between items-center mt-4 text-sm")
            div(class="capitalize") By {{ displayName }}
            LikeAndShare(
                :build="build"
                showLikeCount
            )

</template>

<script>
import LikeAndShare from './likeShare'

export default {
    name: 'BuildCard',
    components: { LikeAndShare },
    props: {
        build: {
            type: Object,
            default: () => {},
        },
        isLazy: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        image() {
            // Split by slashes
            // The first 2 array items are '', and 'staging'
            // The getImageUrl function adds staging or production based upon env
            const [, , key, filename] = this.build.image.split('/')

            const img = {
                width: 610,
                height: 455,
                src: '',
            }

            if (this.$device.isDesktop) {
                img.width = 405
                img.height = 384
            }

            img.src = this.$getImageUrl(key, filename, img.width, img.height, 80)

            return img
        },
        displayName() {
            if (this.build.isInternal) return this.$sitewideData.config?.siteName
            return this.build.displayName
        },
    },
}
</script>
